import axios from "axios";
import { baseUrlApiOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class DealerService {
  private axios = axios.create({
    baseURL: baseUrlApiOtodis,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async updateStopClosing(inputData?: any) {
    try {
      return await this.axios.put<any>("/dealer/stop-closing", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      throw new Error(e.response?.data?.message ?? "Error");
    }
  }

  public async addDealer(inputData?: any) {
    try {
      return await this.axios.post<any>("/dealer", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }

  public async updateDealer(inputData?: any) {
    try {
      return await this.axios.put<any>("/dealer", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
      });
    } catch (e: any) {
      throw new Error(e?.response?.data?.message);
    }
  }
}

export const dealerService = new DealerService();
